import { trimText } from 'utils';
import localization from '../localization';


export default {
    name: {
        isValid: (name) => trimText(name).length > 1,
        message: (lang) => localization[lang].pet_errors.name
    },
    type: {
        isValid: (name) => trimText(name).length > 1,
        message: (lang) => localization[lang].pet_errors.type
    },
    breed: {
        isValid: (name) => trimText(name).length > 1,
        message: (lang) => localization[lang].pet_errors.breed
    },
    weight: {
        isValid: (name) => trimText(name).length > 1,
        message: (lang) => localization[lang].pet_errors.weight
    }
};
